var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');

var redefine = require('../internals/redefine');

var toString = require('../internals/object-to-string'); // `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring


if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, {
    unsafe: true
  });
}